import { Navigate } from 'react-router-dom';
import { UserAuth } from 'store/auth';
import { useAppSelector } from 'store/hooks';
import { useConfigConstantValue } from 'hooks/useConfigConstant';

export function useGetLoginUrl() {
    const userAuth: UserAuth = useAppSelector((state) => state.auth);
    if (userAuth?.configuration?.constants?.SAML_ENABLED) {
        return '/auth/saml/login';
    } else if (userAuth?.configuration?.constants?.GOOGLE_OAUTH2_LOGIN) {
        return '/auth/google/login';
    }
    return '/login';
}

export default function LoginRedirect() {
    const userAuth: UserAuth = useAppSelector((state) => state.auth);
    const checkLoginRedirect =
        !(window.location.href && -1 !== window.location.href.indexOf('/auth/')) &&
        (userAuth?.configuration?.constants?.SAML_ENABLED || userAuth?.configuration?.constants?.GOOGLE_OAUTH2_LOGIN);
    const customAppForUnauthorized = useConfigConstantValue('CUSTOM_APP_FOR_UNAUTHORIZED_USERS');

    if (customAppForUnauthorized && customAppForUnauthorized > '') {
        window.location.href = customAppForUnauthorized;
        return null;
    }

    if (checkLoginRedirect) {
        if (userAuth.configuration.constants.SAML_ENABLED) {
            window.location.href = '/auth/saml/login';
            return null;
        } else if (userAuth.configuration.constants.GOOGLE_OAUTH2_LOGIN) {
            window.location.href = '/auth/google/login';
            return null;
        }
    }

    return <Navigate to="/login" />;
}
